/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tools_QuestsInputs */

const en_control_tools_quests = /** @type {(inputs: Control_Tools_QuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get past a blocker and find your next objective.`)
};

const zh_control_tools_quests = /** @type {(inputs: Control_Tools_QuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遇到任务目标不更新或不知道下一步去哪时，直接查具体步骤。`)
};

/**
* | output |
* | --- |
* | "Get past a blocker and find your next objective." |
*
* @param {Control_Tools_QuestsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tools_quests = /** @type {((inputs?: Control_Tools_QuestsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tools_QuestsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tools_quests(inputs)
	return zh_control_tools_quests(inputs)
});
export { control_tools_quests as "control.tools.quests" }